<div *ngIf="cargando">
  <div class="text-center py-5">
      <mat-spinner class="img-center"></mat-spinner>
  </div>
  <div class="text-center py-5">
    <span>{{guardando ? 'Guardando' : 'Cargando'}} datos...</span>
  </div>
</div>

<div *ngIf="!cargando" [ngClass]="{'m-0': diaIncidencia, 'm-3': !diaIncidencia}">
  <div *ngIf="!horario.idHorario || horario.idHorario == '-'">
    <div class="text-center" *ngIf="!soloConsulta && !diaIncidencia && !aplicarManualmente">
      <h1 class="fw-medium mb-2">Agregar Nuevo Horario</h1>
    </div>
  </div>

  <div *ngIf="editandoHorario && !diaIncidencia && !aplicarManualmente">
    <div class="row g-2 text-start mb-3">
      <div [ngClass]="{'col-4': esDebugger, 'col-6': !esDebugger}">
        <label class="form-label mb-0">Nombre del horario</label>
        <input type="text" class="form-control" [(ngModel)]="horario.nombreHorario" onClick="this.select();" placeholder="Escribe el nombre del horario">
      </div>

      <div *ngIf="horario.detalles.length == 1 && horario.manejoHorario.tipoHorario != TipoHorario.HorasPeriodo" [ngClass]="{'col-4': esDebugger, 'col-6': !esDebugger}">
        <label class="mb-0 text-start">Días de descanso</label>
        <ng-select (open)="ocultarTeclado()" [(ngModel)]="horario.detalles[0].diasDescanso" [items]="diasParaMostrar" [multiple]="true" [closeOnSelect]="false" [virtualScroll]="true" appendTo="body" dropdownPosition="auto">
          <ng-template ng-option-tmp let-item="item">
            <div class="d-flex justify-content-start align-items-center">
              <input class="me-2" type="checkbox" [checked]="horario.detalles[0].diasDescanso.includes(item)" /> {{ item }}
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div class="col-4" *ngIf="esDebugger">
        <label class="form-label mb-0">Tipo de horario</label>
        <ng-select [searchable]="false" [clearable]="false" [items]="tiposHorarios | keyvalue" bindLabel="value" bindValue="key" [(ngModel)]="horario.manejoHorario.tipoHorario" (ngModelChange)="tipoPeriodoChange($event)" placeholder="Selecciona una opción" appendTo="body" dropdownPosition="auto">
        </ng-select>
      </div>
    </div>
  </div>

  <!-- <ng-container *ngIf="horario.tipoPeriodo === TipoPeriodo.Normal"></ng-container> -->
   <ng-container>
    <div *ngFor="let detalle of horario.detalles; index as indexSemana">
      <div class="shadow rounded" [ngClass]="{'mb-5': !diaIncidencia, 'mb-3': diaIncidencia}">
        <mat-card-header class="d-block text-start pt-1">
          <mat-card-title>
            <ng-container *ngIf="diaIncidencia && horario.nombreHorario != 'Horario especial' && !esCambioTurno">
              <div class="text-start fw-semibold h6 ms-2">Horario actual:</div>
              <div class="d-flex justify-content-between mx-4 mt-2">
                <div class="fw-semibold d-flex align-items-center">
                  <mat-icon inline color="warn" fontIcon="calendar_month" style="font-size: 25px; width: 25px; height: 30px;"></mat-icon>
                  <p class="mb-0 ms-2 h6">{{ horario.nombreHorario }}</p>
                </div>
              </div>
              <hr class="text-body-tertiary">
            </ng-container>

            <div class="d-flex justify-content-between mx-4 my-2">
              <div class="fw-semibold d-flex">
                <mat-icon inline color="warn" fontIcon="calendar_month" style="font-size: 30px; width: 30px; height: 30px;"></mat-icon>
                <p class="mb-0 ms-2" *ngIf="!diaIncidencia">{{ horario.nombreHorario }}</p>
                <p class="mb-0 ms-2" *ngIf="esCambioTurno">{{ horario.nombreHorario }}</p>
                <p class="mb-0 ms-2" *ngIf="diaIncidencia && !esCambioTurno">Horario especial</p>
              </div>
              <div class="d-flex align-items-center" *ngIf="false">
                <h5 class="mb-0 text-primary-emphasis">Horario rotativo</h5>
              </div>
              <div *ngIf="!soloConsulta && (horario.inicioTxt != '-' || horario.finTxt != '-') && !editandoHorario" class="d-block">
                <small class="fs-6 fw-normal opacity-75 mx-4" *ngIf="horario.inicioTxt != '-'">Activo desde: {{ formatoFecha(horario.inicio) }}</small>
                <small class="fs-6 fw-normal opacity-75" *ngIf="horario.finTxt != '-'">Fecha terminación: {{ formatoFecha(horario.fin) }}</small>
              </div>
            </div>
            <hr class="text-body-tertiary" *ngIf="!diaIncidencia && horario.nombreHorario != 'Horario especial'">
          </mat-card-title>
        </mat-card-header>

        <mat-card-content [ngClass]="{'pb-0': diaIncidencia}">
          <div class="row g-2 mx-4 mb-3 align-items-end" *ngIf="horario.detalles.length > 1 && !diaIncidencia">
            <div class="col-3 fw-semibold">
              <p>Semana {{ indexSemana + 1 }}</p>
            </div>
            <div class="col-9" *ngIf="editandoHorario">
              <label class="mb-0 text-start">Días de descanso</label>
              <ng-select (open)="ocultarTeclado()" [(ngModel)]="horario.detalles[indexSemana].diasDescanso" [items]="diasParaMostrar" [multiple]="true" [closeOnSelect]="false" [virtualScroll]="true" appendTo="body" dropdownPosition="auto">
                <ng-template ng-option-tmp let-item="item">
                  <div class="d-flex justify-content-start align-items-center">
                    <input class="me-2" type="checkbox" [checked]="horario.detalles[indexSemana].diasDescanso.includes(item)" /> {{ item }}
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="text-danger h6 mx-2" *ngIf="aplicarManualmente">
            Por favor, ingrese la hora en formato de 24 horas (HH:mm). Ejemplo: 0830 para 8:30 AM ó 1545 para 3:45 PM.
          </div>
          <!-- <div class="d-flex justify-content-end align-items-center mb-3" *ngIf="aplicarManualmente">
            <div class="form-check mx-2">
              <input class="form-check-input" type="checkbox" id="aplicarTodosChkManual" [(ngModel)]="aplicarTodos">
              <label class="form-check-label fw-bold" for="aplicarTodosChkManual">Aplicar a todos</label>
            </div>
          </div> -->
          <div class="d-flex align-items-center mx-3" *ngIf="editandoHorario && !diaIncidencia" [ngClass]="{'justify-content-between': esDebugger}">
            <div *ngIf="esDebugger">
              <h3 class="mt-2 fw-medium" *ngIf="horario.manejoHorario.tipoHorario == TipoHorario.Semanal">Tipo de Horario: Semanal</h3>
              <h3 class="mt-2 fw-medium" *ngIf="horario.manejoHorario.tipoHorario == TipoHorario.Dia">Tipo de Horario: Semanal base número de días</h3>
              <h3 class="mt-2 fw-medium" *ngIf="horario.manejoHorario.tipoHorario == TipoHorario.HorasPeriodo">Tipo de Horario: Bolsa de horas</h3>
              <h3 class="mt-2 fw-medium" *ngIf="horario.manejoHorario.tipoHorario == TipoHorario.HorasDiaSemana">Tipo de Horario: Horas por día de semana</h3>
              <h3 class="mt-2 fw-medium" *ngIf="horario.manejoHorario.tipoHorario == TipoHorario.HorasDia">Tipo de Horario: Horas por número de días</h3>
            </div>
            <div class="d-flex justify-content-end align-items-center gap-3">
              <div class="form-check" *ngIf="editandoHorario && !aplicarManualmente">
                <input class="form-check-input" type="checkbox" id="ocultarHorarioChk" [(ngModel)]="horario.manejoHorario.restringido">
                <label class="form-check-label fw-bold" for="ocultarHorarioChk">Ocultar horario</label>
              </div>
              <div class="form-check" *ngIf="esDebugger && horario.manejoHorario.tipoHorario == TipoHorario.Semanal">
                <input class="form-check-input" type="checkbox" id="rotativoChk" [(ngModel)]="horario.manejoHorario.esRotativo">
                <label class="form-check-label fw-bold" for="rotativoChk">Horario rotativo</label>
              </div>
              <div class="form-check" *ngIf="horario.manejoHorario.tipoHorario == TipoHorario.Semanal">
                <input class="form-check-input" type="checkbox" id="aplicarTodosChk" [(ngModel)]="aplicarTodos">
                <label class="form-check-label fw-bold" for="aplicarTodosChk">Aplicar a todos</label>
              </div>
              <div class="fw-bold" (click)="esHorarioNocturno()" style="min-height: 1.5rem;">
                Horario Nocturno: {{horarioNocturno ? 'Activado' : 'Desactivado'}}
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end text-primary mx-3 mb-3" *ngIf="horario.manejoHorario.tipoHorario == TipoHorario.HorasPeriodo">
            Periodicidad es aplicada a partir de la fecha de asignación al empleado
          </div>

          <div class="row g-2 text-start mb-3 mx-3 justify-content-center" *ngIf="horario.manejoHorario.tipoHorario == TipoHorario.HorasPeriodo">
            <div class="col-5 text-start row g-2 px-4 border-end">
              <div class="text-primary col-12">Parámetros</div>
              <div class="col-6">
                <label class="form-label mb-0">Horas a cubrir</label>
                <input type="text" class="form-control" [(ngModel)]="horario.manejoHorario.horasPorPeriodo">
              </div>
              <div class="col-6">
                <label class="form-label mb-0">Periodicidad</label>
                <ng-select [searchable]="false" [clearable]="false" [items]="tiposPeriodosHoras | keyvalue" bindLabel="value" bindValue="key" [(ngModel)]="horario.manejoHorario.tipoPeriodo" (ngModelChange)="tipoPeriodoHorasChange($event)" placeholder="Selecciona una opción" appendTo="body" dropdownPosition="auto">
                </ng-select>
              </div>
            </div>

            <div class="col-5 row text-start g-2 mx-4">
              <div class="text-primary col-12">Opcional</div>
              <div class="col-6">
                <label class="form-label mb-0">Mínimo de horas diarias</label>
                <input type="text" class="form-control" [(ngModel)]="horario.manejoHorario.minimoHorasDiarias">
              </div>
              <div class="col-6">
                <div class="form-check mb-0" style="min-height: 0;">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="horario.manejoHorario.manejaMinutoIngreso">
                  <label class="form-check-label fw-bold">Maneja minutos de entrada</label>
                </div>
                <div class="input-group">
                  <span class="input-group-text">:</span>
                  <input type="text" class="form-control" [(ngModel)]="horario.manejoHorario.minutoIngreso" [disabled]="!horario.manejoHorario.manejaMinutoIngreso">
                </div>
              </div>
            </div>
          </div>

          <ng-container *ngIf="horario.manejoHorario.tipoHorario != TipoHorario.HorasPeriodo">
             <div class="row align-items-center my-2 mx-2 border-bottom border-light-subtle" [ngClass]="{'pb-3': diaIncidencia}" *ngFor="let dia of diasParaMostrar">
              <div class="col-1 text-center">
                <h3 class="mt-2 fw-medium">{{ dia }}</h3>
              </div>
              <div [ngClass]="{ 'col-8': editandoHorario, 'col-11': !diaIncidencia && !editandoHorario, 'text-center': aplicarManualmente, 'col-7 col-xl-8': diaIncidencia, 'd-flex justify-content-between pb-3': (horario.manejoHorario.tipoHorario == TipoHorario.HorasDiaSemana || horario.manejoHorario.tipoHorario ==  TipoHorario.HorasDia) && !isDiaDescanso(detalle, dia) }">
                <div *ngIf="isDiaDescanso(detalle, dia)">
                  <!-- <div class="d-flex justify-content-between">
                    <div id="descanso1" class="fw-medium ms-2 fs-7">
                      <span class="opacity-50">  Descanso  </span>
                    </div>
                    <div id="horaSalida" class="d-flex align-content-center fw-medium me-5 fs-7">
                      <span class="opacity-50">  Descanso  </span>
                    </div>
                  </div> -->
                  <mat-slider min="0" [max]="24" [step]="0.25" style="width: 50%" showTickMarks [color]="'success'" [disabled]="true">
                    <input matSliderThumb [(ngModel)]="valorCero" (ngModelChange)="onInputChangeValorCero($event)">
                  </mat-slider>
                </div>

                <div class="d-flex justify-content-between w-100" *ngIf="horario.manejoHorario.tipoHorario != TipoHorario.HorasDiaSemana && horario.manejoHorario.tipoHorario != TipoHorario.HorasDia">
                  <div *ngFor="let horarioDia of detalle.horariosSemana[dia]; let indexRango = index" class="d-flex justify-content-between align-items-center w-100 px-3">
                    <div id="horaEntrada" class="fw-medium fs-7 px-1" [ngClass]="{ 'primary': horarioDia.nocturno, 'warn': !horarioDia.nocturno }">
                      <input *ngIf="aplicarManualmenteIncidencia" type="text" class="form-control" placeholder="{{ formatearHora(horarioDia.horaEntrada) }}" [(ngModel)]="horarioDia.horaEntradaFormateada" (input)="procesarConRetraso(horarioDia.horaEntradaFormateada, horarioDia, 'entrada', dia, indexSemana, indexRango, aplicarTodos)" onClick="this.select();">
                      <input *ngIf="aplicarManualmente" type="text" class="form-control" placeholder="{{ formatearHora(horarioDia.horaEntrada) }}" [(ngModel)]="horarioDia.horaEntradaFormateada" (input)="procesarConRetraso(horarioDia.horaEntradaFormateada, horarioDia, 'entrada', dia, indexSemana, indexRango, aplicarTodos)" onClick="this.select();">
                      <div *ngIf="!aplicarManualmente && !aplicarManualmenteIncidencia">{{ formatearHora(horarioDia.horaEntrada) }}</div>
                    </div>
                    <div id="horaSalida" class="fw-medium fs-7 px-1" [ngClass]="{ 'primary': horarioDia.nocturno, 'warn': !horarioDia.nocturno }">
                      <input *ngIf="aplicarManualmenteIncidencia" type="text" class="form-control" placeholder="{{ formatearHora(horarioDia.horaSalida) }}" [(ngModel)]="horarioDia.horaSalidaFormateada" (input)="procesarConRetraso(horarioDia.horaSalidaFormateada, horarioDia, 'salida', dia, indexSemana, indexRango, aplicarTodos)"onClick="this.select();">
                      <input *ngIf="aplicarManualmente" type="text" class="form-control" placeholder="{{ formatearHora(horarioDia.horaSalida) }}" [(ngModel)]="horarioDia.horaSalidaFormateada" (input)="procesarConRetraso(horarioDia.horaSalidaFormateada, horarioDia, 'salida', dia, indexSemana, indexRango, aplicarTodos)"onClick="this.select();">
                      <div *ngIf="!aplicarManualmente && !aplicarManualmenteIncidencia">{{ formatearHora(horarioDia.horaSalida) }}</div>
                      <!-- <div *ngIf="!!horarioDia.horaSalida && horarioDia.nocturno">
                        <mat-icon class="text-danger mt-1 me-2">start</mat-icon>
                      </div>
                      <div *ngIf="detalle.horariosSemana[dia].length > 1 && !horarioDia.nocturno">
                        <mat-icon class="text-info mx-3">call_split</mat-icon>
                      </div> -->
                    </div>
                  </div>
                </div>

                <ng-container *ngIf="!aplicarManualmente && !aplicarManualmenteIncidencia && horario.manejoHorario.tipoHorario != TipoHorario.HorasDiaSemana && horario.manejoHorario.tipoHorario != TipoHorario.HorasDia">
                  <mat-slider *ngFor="let horarioDia of detalle.horariosSemana[dia]; let indexRango = index"
                            [min]="horarioDia.nocturno ? 0 : indexRango === 0 ? 0 : detalle.horariosSemana[dia][indexRango - 1].horaSalida"
                            [max]="horarioDia.nocturno ? 24 :indexRango < detalle.horariosSemana[dia].length - 1 ? detalle.horariosSemana[dia][indexRango + 1].horaEntrada : 24"
                            [step]="0.25"
                            [ngStyle]="{'width': (92 / detalle.horariosSemana[dia].length) + '%'}"
                            showTickMarks
                            [color]="horarioDia.nocturno ? 'warn' : detalle.horariosSemana[dia].length > 1 ? 'info' : 'primary'"
                            [disabled]="!editandoHorario"
                            (input)="actualizarSliders(dia, indexSemana, indexRango)">
                    <input matSliderStartThumb [(ngModel)]="horarioDia.horaEntrada" (ngModelChange)="onInputChangeHoraEntrada($event, indexRango, dia)">
                    <input matSliderEndThumb [(ngModel)]="horarioDia.horaSalida" (ngModelChange)="onInputChangeHoraSalida($event, indexRango, dia)">
                  </mat-slider>
                </ng-container>

                <ng-container *ngIf="!aplicarManualmente && !aplicarManualmenteIncidencia && horario.manejoHorario.tipoHorario == TipoHorario.HorasDiaSemana || horario.manejoHorario.tipoHorario == TipoHorario.HorasDia">
                  <div class="text-start row g-2 justify-content-center align-items-end" *ngIf="!isDiaDescanso(detalle, dia)">
                    <ng-container *ngFor="let horarioDia of detalle.horariosSemana[dia]; let indexRango = index">
                      <div class="col-2 mt-4 px-2">
                        <div class="text-primary col-12" *ngIf="indexRango === 0">Parámetros</div>
                        <label class="form-label mb-0">
                          {{ indexRango === 0 ? 'Horas a cubrir' : (indexRango === 1 ? 'Descanso' : 'Horas a cubrir') }}
                        </label>
                        <input type="text" class="form-control" [(ngModel)]="horarioDia.horasPorDia">
                      </div>
                      <!-- <div class="col-5 row g-2 px-4">
                        <div class="text-primary col-12" *ngIf="indexRango === 0">Parámetros</div>
                        <div [ngClass]="{'col-4': indexRango > 0, 'col-12': indexRango === 0}">
                          <label class="form-label mb-0">
                            {{ indexRango === 0 ? 'Horas a cubrir' : (indexRango === 1 ? 'Descanso' : 'Horas a cubrir') }}
                          </label>
                          <input type="text" class="form-control" [(ngModel)]="horarioDia.horasPorDia">
                        </div>
                      </div> -->
                    </ng-container>

                    <div class="col-6 row g-2 border-start" *ngIf="detalle.horariosSemana[dia].length > 0">
                      <div class="col-12 text-primary">Opcional</div>
                      <div class="col-6">
                        <label class="form-label mb-0">Mínimo de horas diarias</label>
                        <input type="text" class="form-control" [(ngModel)]="detalle.horariosSemana[dia][0].minimoHorasDiarias">
                      </div>
                      <div class="col-6">
                        <div class="form-check mb-0" style="min-height: 0;">
                          <input class="form-check-input" type="checkbox" [(ngModel)]="detalle.horariosSemana[dia][0].manejaMinutoIngreso">
                          <label class="form-check-label fw-bold">Minutos de entrada</label>
                        </div>
                        <div class="input-group">
                          <span class="input-group-text">:</span>
                          <input type="text" class="form-control" [(ngModel)]="detalle.horariosSemana[dia][0].minutoIngreso" [disabled]="!detalle.horariosSemana[dia][0].manejaMinutoIngreso">
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="col-3 d-grid justify-content-center" *ngIf="editandoHorario">
                <ng-container *ngIf="!aplicarManualmente && diaIncidencia">
                  <div class="mb-2">
                    <button mat-raised-button class="mx-2 text-primary" (click)="aplicarManualmenteIncidencia = !aplicarManualmenteIncidencia">
                      {{ aplicarManualmenteIncidencia ? 'Cambiar a selección con barra' : 'Aplicar manualmente' }}
                    </button>
                  </div>
                </ng-container>
                <div class="d-flex justify-content-center">
                  <div class="mt-auto me-auto" *ngIf="isDiaDescanso(detalle, dia) && !editandoHorario">
                    <mat-icon class="opacity-50">bed</mat-icon>
                  </div>
                  <div class="mt-auto me-auto" *ngIf="!!detalle.horariosSemana[dia] && detalle.horariosSemana[dia].length > 0 && !editandoHorario">
                    <mat-icon
                      [ngClass]="{'text-danger' : detalle.horariosSemana[dia][detalle.horariosSemana[dia].length - 1].nocturno, 'text-primary': !detalle.horariosSemana[dia][detalle.horariosSemana[dia].length - 1].nocturno }">
                      {{detalle.horariosSemana[dia][detalle.horariosSemana[dia].length - 1].nocturno ? 'dark_mode' : 'sunny' }}
                    </mat-icon>
                  </div>
                  <button mat-raised-button matTooltip="Agregar hora" (click)="agregarRangoHora(detalle, dia, indexSemana)" [disabled]="!editandoHorario || isDiaDescanso(detalle, dia) || detalle.horariosSemana[dia].length >= 4"
                    *ngIf="!soloConsulta" >
                    <mat-icon class="me-0">add</mat-icon>
                  </button>
                  <button class="mx-1" mat-raised-button matTooltip="Remover hora" (click)="removerRangoHora(detalle, dia, indexSemana)" [disabled]="!editandoHorario || isDiaDescanso(detalle, dia) || detalle.horariosSemana[dia].length == 1"
                    *ngIf="!soloConsulta">
                    <mat-icon class="me-0">remove</mat-icon>
                  </button>
                  <button *ngIf="!!detalle.horariosSemana[dia] && detalle.horariosSemana[dia].length > 0 && editandoHorario" mat-raised-button
                    (click)="cambiarHorarioNocturno(detalle, dia, indexSemana)" [disabled]="!editandoHorario || isDiaDescanso(detalle, dia)">
                    <mat-icon class="m-0" [ngClass]="{'text-danger' : detalle.horariosSemana[dia][detalle.horariosSemana[dia].length - 1].nocturno, 'text-primary': !detalle.horariosSemana[dia][detalle.horariosSemana[dia].length - 1].nocturno }">
                      {{detalle.horariosSemana[dia][detalle.horariosSemana[dia].length - 1].nocturno ? 'dark_mode' : 'sunny' }}
                    </mat-icon>
                  </button>
                </div>
              </div>
              <ng-container *ngIf="aplicarManualmenteIncidencia">
                <div class="text-danger h6 mt-4 mb-0">
                  Por favor, ingrese la hora en formato de 24 horas (HH:mm). Ejemplo: 0830 para 8:30 AM ó 1545 para 3:45 PM.
                </div>
              </ng-container>
            </div>
          </ng-container>
        </mat-card-content>

        <div class="d-flex justify-content-end align-items-center p-2 gap-2" *ngIf="!diaIncidencia">
          <button *ngIf="editandoHorario && horario.manejoHorario.tipoHorario == TipoHorario.Dia || horario.manejoHorario.tipoHorario == TipoHorario.HorasDia" mat-raised-button color="primary" (click)="agregarDia()">
              Añadir día
          </button>
          <button *ngIf="editandoHorario && horario.manejoHorario.tipoHorario == TipoHorario.Dia || horario.manejoHorario.tipoHorario == TipoHorario.HorasDia" mat-raised-button color="warn" (click)="eliminarDia()" [disabled]="semanaPorDia.length <= 1">
            Eliminar día
          </button>
          <button *ngIf="horario.manejoHorario.tipoHorario != TipoHorario.HorasDiaSemana && horario.manejoHorario.tipoHorario != TipoHorario.HorasDia && horario.manejoHorario.tipoHorario != TipoHorario.HorasPeriodo" mat-raised-button class="mx-2 text-primary" (click)="abrirHorasManualmenteModal(horario, true)">Aplicar manualmente</button>
          <button *ngIf="aplicarManualmente" mat-raised-button class="mx-1 bg-success text-white" (click)="aplicarHoras()">Aplicar horas</button>
          <button *ngIf="aplicarManualmente" mat-raised-button mat-dialog-close class="mx-1 bg-danger text-white">Cancelar</button>
          <button *ngIf="editandoHorario && !aplicarManualmente" class="bg-success text-white" (click)="guardarHorario()" mat-raised-button>Guardar</button>
          <button *ngIf="editandoHorario && !aplicarManualmente" class="text-white bg-danger" (click)="deshacerCambios()" mat-raised-button>Deshacer</button>
          <button *ngIf="editandoHorario && horario.finTxt == '-' && !aplicarManualmente" class="bg-danger text-white" (click)="eliminarHorario()" mat-raised-button>Eliminar</button>
          <button *ngIf="!editandoHorario && !soloConsulta && !aplicarManualmente" class="bg-primary text-white" (click)="editarHorario()" mat-raised-button>Modificar</button>
          <button *ngIf="horario.manejoHorario.tipoHorario == TipoHorario.Semanal && editandoHorario && indexSemana == 0 && !aplicarManualmente" class="bg-info text-white" (click)="agregarSemana()" [disabled]="horario.detalles.length > 1" mat-raised-button>Añadir semana</button>
          <button *ngIf="editandoHorario && indexSemana == 1 && !aplicarManualmente" class="bg-danger text-white" (click)="eliminarSemana()" [disabled]="horario.detalles.length == 1" mat-raised-button>Eliminar semana</button>
        </div>
      </div>
    </div>
   </ng-container>
</div>
